import { cn } from '../lib/utils';

// ─── Unified color maps that work in both light and dark themes ───
export const STATUS_COLORS = {
  'Urgent': 'bg-red-500/15 text-red-600 dark:text-red-400 border-red-500/30',
  'Needs Completed Today': 'bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30',
  'Pending': 'bg-stone-500/15 text-stone-600 dark:text-stone-400 border-stone-500/30',
  'Done': 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30',
  'On Hold/No Action': 'bg-gray-500/15 text-gray-600 dark:text-gray-400 border-gray-500/30',
};

export const URGENCY_COLORS = {
  'Critical': 'bg-red-600 text-white border-red-600',
  'High': 'bg-amber-500 text-white border-amber-500',
  'Normal': 'bg-slate-500/20 text-slate-700 dark:text-slate-300 border-slate-500/30',
  'Low': 'bg-slate-400/15 text-slate-500 dark:text-slate-400 border-slate-400/25',
};

export const ACTION_COLORS = {
  'Completed': 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30',
  'Needs Follow Up': 'bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30',
  'Waiting on Borrower': 'bg-stone-500/15 text-stone-600 dark:text-stone-400 border-stone-500/30',
};

export function StatusBadge({ status, className }) {
  const c = STATUS_COLORS[status] || 'bg-gray-500/15 text-gray-600 dark:text-gray-400 border-gray-500/30';
  return (
    <span data-testid={`status-badge-${status?.toLowerCase().replace(/[\s\/]+/g, '-')}`}
      className={cn('inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold border', c, status === 'Urgent' && 'animate-pulse-urgent', className)}>
      {status}
    </span>
  );
}

export function UrgencyBadge({ urgency, className }) {
  const c = URGENCY_COLORS[urgency] || 'bg-gray-500/15 text-gray-600 dark:text-gray-400';
  return (
    <span data-testid={`urgency-badge-${urgency?.toLowerCase()}`}
      className={cn('inline-flex items-center px-2 py-0.5 rounded text-xs font-bold', c, className)}>
      {urgency}
    </span>
  );
}

export function ActionBadge({ action, className }) {
  const c = ACTION_COLORS[action] || 'bg-gray-500/15 text-gray-600 dark:text-gray-400 border-gray-500/30';
  return (
    <span data-testid={`action-badge-${action?.toLowerCase().replace(/[\s]+/g, '-')}`}
      className={cn('inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold border', c, className)}>
      {action}
    </span>
  );
}

export function InlineSelect({ value, options, onChange, testId, colorMap }) {
  const cc = colorMap?.[value] || 'bg-muted text-foreground border-border';
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId}
      className={cn('inline-select text-xs font-semibold rounded px-2 py-1 border cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring/50 transition-colors', cc)}>
      {options.map(o => <option key={o} value={o}>{o}</option>)}
    </select>
  );
}
